import { Link } from 'react-router-dom';

export default function Hello() {
  return (
    <main className="min-h-screen flex flex-col items-center justify-center bg-dgrp-bg-deep text-white">
      <div className="max-w-2xl w-full px-8 text-center">
        <div className="text-xs uppercase tracking-[0.3em] text-dgrp-red mb-6 h-display">
          The Disruption Group
        </div>
        <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight h-display">
          Recruiting & Onboarding
        </h1>
        <p className="text-dg-mist text-lg mb-10">
          A purpose-built platform for sourcing, vetting, and launching DG agents.
        </p>
        <Link
          to="/login"
          className="inline-flex items-center justify-center px-6 py-3 rounded bg-dgrp-red text-white font-semibold hover:bg-dgrp-red-hover transition"
        >
          Sign in
        </Link>
      </div>
    </main>
  );
}
